import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "config/reactQueryConfig";
import LoadingContainer from "components/Containers/LoadingContainer";
import ModalContainer from "components/Containers/ModalContainer";
import PrintContainer from "components/Containers/PrintContainer";
import PageRoutes from "config/routeConfig";
import { SnackbarProvider } from "notistack";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "config/themeConfig";
import { CookiesProvider } from "react-cookie";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "swiper/css/bundle";

const App = () => {
  return (
    <CookiesProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider
            anchorOrigin={anchorOriginProps}
            autoHideDuration={3000}
          >
            <LoadingContainer>
              <PageRoutes />
            </LoadingContainer>
            <ModalContainer />
            <PrintContainer />
          </SnackbarProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

const anchorOriginProps = {
  horizontal: "right" as const,
  vertical: "bottom" as const,
};

export default App;
